export const AuthType = {
  Create: 'Yeni Kayit',
  Update: 'Güncelleme',
  Delete: 'Silme',
}
